import api from "../api/axios";
import {
  CreateContactPayload,
  UpdateContactPayload,
} from "../Types/CompanyProfile/CompanyContact";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export const COMPCONTACT_QUERY_KEY = ["company-contact"];

export const companycontactService = {
  createContact: async (payload: CreateContactPayload) => {
    const response = await api.post(`api/company-contact`, payload);
    return response.data;
  },

  updateContact: async (id: number, payload: UpdateContactPayload) => {
    const response = await api.patch(`api/company-contact/${id}`, payload);
    return response.data.data;
  },

  getContactByCompany: async (company_code: string) => {
    const response = await api.get(
      `api/company-contact/${company_code}/company`,
    );
    return response.data.data;
  },

  getContactById: async (id: number) => {
    const response = await api.get(`api/company-contact/${id}`);
    return response.data.data;
  },
};
